// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"style_dropzone__3WL71"};